import { apiInstance } from 'utils/request'
import parseError from 'helpers/parseServerError'

export const getArcCategories = () => {
  return apiInstance
    .get('/arc_categories?page[size]=100', {
      headers: {
        'Accept': 'application/vnd.api+json',
      }
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc categories')
    })
}

export const createArcCategory = (data) => {
  return apiInstance
    .post('/arc_categories', {
      data,
    }, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc category hasn't been created")
    })
}

export const updateArcCategory = (id, data) => {
  return apiInstance
    .put(`/arc_categories/${id}`, {
      data,
    }, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc category hasn't been updated")
    })
}

export const deleteArcCategory = (id) => {
  return apiInstance
    .delete(`/arc_categories/${id}`, {
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc category hasn't been deleted")
    })
}